import React, { useEffect, useState } from 'react';
import './OpportunityDetails.scss';
import { Badge, Card, CardBody, CardHeader } from 'reactstrap';
import BootstrapTable from '../../../../components/react-bootstrap-table-next/react-bootstrap-table2';
import {
    MarketplaceOpportunityStatus,
    MarketplaceOpportunityStatusList,
} from '../../../../slices/marketplace/opportunity/models/opportunity-status';
import { useStateSelector } from '../../../../store/selectors';
import createNotification from '../../../../utils/createNotification';
import { setSelectedOpportunity } from '../../../../slices/marketplace/opportunity/opportunity.slice';
import { useDispatch } from 'react-redux';
import { TimelineActionStatus } from '../../../../slices/marketplace/timeline/models/enums/timeline-action-status.enum';
import { TimelineActionType } from '../../../../slices/marketplace/timeline/models/timeline-action-type.model';
import { LevelsOfService } from '../../../../slices/marketplace/timeline/models/enums/level-of-service.enum';
import { GetOpportunity } from '../../../../slices/marketplace/opportunity/thunks/get-opportunity.thunk';
import { GetSellerProfileByOpportunityId } from '../../../../slices/profiles-data-slice/thunks/get-seller-profile-by-opportunity-id.thunk';
import LegalDocumentInformationPopup from '../../../../components/LegalDocumentInformationPopup/LegalDocumentInformationPopup';
import { DocumentSignModal } from '../../../../components/DocumentSignModal/DocumentSignModal';
import NdaTermsPopup from '../../../ConnectMarketplaceDashboard/NdaTermsPopup/NdaTermsPopup';
import { TimelineParty } from '../../../../slices/marketplace/timeline/models/enums/timeline-party.enum';
import { NdaTermSelection } from '../../../../slices/marketplace/timeline/models/nda-term-selection';
import { FinalNdaTermsPopup } from '../../../ConnectMarketplaceDashboard/NdaTermsPopup/FinalNdaTermsPopup';
import { PrefilledTags } from '../../../../models/PrefilledTags/PrefilledTags';
import { TimelineEventStatus } from '../../../../slices/marketplace/timeline/models/enums/timeline-event-status.enum';
import ValueRangeModal from '../ValueRangeModal/ValueRangeModal';
import EngagementTimeline from '../../../ConnectMarketplaceDashboard/EngagementTimeline/EngagementTimeline';
import { useSearchParams } from 'react-router-dom';
import { USER_ROLES } from '../../../../utils/constants';
import { stateToCodeMapper } from '../../../../utils/locationsHelper';
import BuyersEngagementDocuments from './BuyersEngagementDocuments/BuyersEngagementDocuments';
import { EngagementPractice } from '../../../../slices/marketplace/timeline/models/engagement-practice';
import {
    LocationType,
    LocationTypeOptions,
} from '../../../../slices/marketplace/timeline/models/enums/location-type.enum';
import {
    OwnershipType,
    OwnershipTypeOptions,
} from '../../../../slices/marketplace/timeline/models/enums/ownership-type.enum';
import {
    RevenueGrowthRate,
    RevenueGrowthRateOptions,
} from '../../../../slices/marketplace/timeline/models/enums/revenue-growth.enum';
import moment from 'moment';
import DeadlineDocket from '../../../ConnectMarketplaceDashboard/DeadlineDocket/DeadlineDocket';
import { DocumentDetailsContentType } from '../../../../slices/marketplace/timeline/models/enums/document-details-content-type';
import EngagementDocumentAccessPaymentComponent from '../../../../components/PaymentDialog/EngagementDocumentAccessPaymentComponent/EngagementDocumentAccessPaymentComponent';
import { LoadMarketplacePricing } from '../../../../slices/marketplace/pricing/load-marketplace-pricing.thunk';
import {
    EngagementPaymentPricingDetails,
    PricesCalculationHelper,
} from '../../../../utils/pricesCalculationHelper';
import { EngagementDocumentType } from '../../../../wallet/models/EngagementDocumentType';
import { DocumentDetailsStatus } from '../../../../slices/marketplace/timeline/models/enums/document-details-status.enum';
import { MarketplaceOpportunity } from '../../../../slices/marketplace/opportunity/models/opportunity';
import { Timeline } from '../../../../slices/marketplace/timeline/models/timeline.model';
import { MarketplaceCommsHub } from '../../../AdminMarketplace/MarketplaceTabs/MarketplaceCommsHub/MarketplaceCommsHub';
import { useFeatureFlag } from '../../../../custom-hooks/useFeatureFlag';
import { FeatureFlagsEnum } from '../../../FeatureFlags/FeatureFlags.enum';
import {
    BuyerOppMarketplaceTabs,
    BuyerOppMarketplaceTab,
} from '../../../../slices/marketplace/timeline/models/enums/buyer-opportunity-details-tab.enum';
import EngagementHistoryTable from '../../../../components/EngagementHistoryTable/EngagementHistoryTable';
import SellerProfileTab from './SellerProfileTab/SellerProfileTab';
import { DealTeam } from './DealTeam/DealTeam';
import OpportunityDataRoomHost from './OpportunityDataRoomHost/OpportunityDataRoomHost';
import { NotificationFlagsCategories } from '../../../../models/NotificationFlags/NotificationFlagsCategories';
import { NotificationFlag } from '../../../../components/NotificationFlag/NotificationFlag';
import {
    TeamMemberPermissions,
    TeamMemberPermissionsHelper,
} from '../MyTeamMembers/TeamMemberPermissionsHelper';
import {
    InternalTeamMemberRole,
    TeamMemberType,
} from '../MyTeamMembers/Models/Enums';
import { RefreshNotificationFlags } from '../../../../slices/notification-flags/refresh-notification-flags';
import { MarketplaceSellerProfile } from '../../../../slices/profiles-data-slice/models/marketplace-seller-profile';
import {
    sellerDataDifferenceTracker,
    SellerDataDifferences,
} from '../../../../utils/sellerDataDifferenceTracker';
import { useServiceFocuses } from '../../../../custom-hooks/useServiceFocuses';
import { isOtherFocus } from '../../../UserPages/Login/Modals/PracticeRegistrationForm/utils';
import CurrentProcessCommercialTerms from '../CurrentProcessCommercialTerms/CurrentProcessCommercialTerms';

interface OpportunityDetailsProps {
    refreshOpportunities: () => void;
}
export const OpportunityDetails = (props: OpportunityDetailsProps) => {
    const is28Implemented = useFeatureFlag(
        FeatureFlagsEnum.FF_MrktplcSellers_2_8
    );
    const isFF_MrktplcBuyers_3_6Enabled = useFeatureFlag(
        FeatureFlagsEnum.FF_MrktplcBuyers_3_6
    );
    const isFF_MrktplcBuyers_3_8Enabled = useFeatureFlag(
        FeatureFlagsEnum.FF_MrktplcBuyers_3_8
    );
    const serviceFocuses = useServiceFocuses();
    const [shouldUploadDocument, setShouldUploadDocument] = useState(false);
    const [actionIdForDocumnetUpload, setActionIdForDocumnetUpload] =
        useState(0);
    const selectedOpportunity = useStateSelector(
        (state) => state.opportunities.selectedOpportuity
    );

    const buyerProfile = useStateSelector(
        (state) => state.buyersState.targetBuyer
    );

    const [currentPermissions, setCurrentPermissions] =
        useState<TeamMemberPermissions>({
            permission:
                selectedOpportunity.teamMemberType === TeamMemberType.Internal
                    ? selectedOpportunity.internalPermissions
                    : selectedOpportunity.externalPermissions,
            type: selectedOpportunity.teamMemberType,
            isPrimaryBuyer: selectedOpportunity.isPrimaryBuyer,
        } as TeamMemberPermissions);
    const [lastSelectedOpportunityId, setLastSelectedOpportunityId] =
        useState(0);
    const axios = useStateSelector((state) => state.core.axios);
    const dispatch = useDispatch() as any;
    const [isNdaTermPopupVisible, setIsNdaTermPopupVisible] = useState(false);
    const [isFinalNdaTermPopupVisible, setIsFinalNdaTermPopupVisible] =
        useState(false);
    const buyer = useStateSelector((s) => s.buyersState.targetBuyer);

    const [highlightDocumentId, setHighlightDocumentId] = useState('');
    const [activeEventId, setActiveEventId] = useState<string>('');
    const [ndaTermSelection, setNdaTermSelection] =
        useState<NdaTermSelection>(null);
    const [isRangeOfValueVisible, setIsRangeOfValueVisible] = useState(false);
    const [selectedEventId, setSelectedEventId] = useState<string | null>(null);
    const [selectedActionId, setSelectedActionId] = useState(0);
    const [isRangeOfValueReadonly, setIsRangeOfValueReadonly] = useState(false);
    const [rangeOfValueMinValue, setRangeOfValueMinValue] = useState(0);
    const [rangeOfValueMaxValue, setRangeOfValueMaxValue] = useState(0);
    const [
        isLegalDocumentInfoConfirmationPopupVisible,
        setIsLegalDocumentInfoConfirmationPopupVisible,
    ] = useState(false);
    const [
        isDocumentAccessFeeCheckoutPopupVisible,
        setIsDocumentAccessFeeCheckoutPopupVisible,
    ] = useState(false);
    const [documentToSign, setDocumentToSign] = useState<number>();
    const [isDocumentToSignFetching, setIsDocumentToSignFetching] =
        useState(false);
    const [availableTabls, setAvailaleTabs] = useState([]);
    const [
        engagementHistoryRefreshTrigger,
        setEngagementHistoryRefreshTrigger,
    ] = useState(false);
    const [isConfirmingRangeOfValue, setIsConfirmingRangeOfValue] =
        useState(false);

    const sellerProfile = useStateSelector(
        (state) => state.profilesData.selectedPofile
    );

    const [dataDifferences, setDataDifferences] =
        useState<SellerDataDifferences>([]);

    useEffect(() => {
        setEngagementHistoryRefreshTrigger((prev) => !prev);

        const userPermissions = {
            isPrimaryBuyer: selectedOpportunity.isPrimaryBuyer,
            permission: selectedOpportunity.internalPermissions,
            type: selectedOpportunity.teamMemberType,
        } as TeamMemberPermissions;
        setCurrentPermissions(userPermissions);

        dispatch(
            GetSellerProfileByOpportunityId(selectedOpportunity.opportunityId)
        );
    }, [selectedOpportunity]);

    useEffect(() => {
        const marketplaceSellerProfile =
            sellerProfile as MarketplaceSellerProfile;
        if (selectedOpportunity && marketplaceSellerProfile?.practiceProfiles) {
            const differences = sellerDataDifferenceTracker(
                selectedOpportunity,
                marketplaceSellerProfile.practiceProfiles,
                serviceFocuses
            );
            setDataDifferences(differences);
        }
    }, [selectedOpportunity, sellerProfile]);

    const isExternalMember = () => {
        return selectedOpportunity.teamMemberType === TeamMemberType.External;
    };

    const renderBadgeForDifference = (
        targetPracticeId: number,
        targetField: string,
        differences: SellerDataDifferences
    ) => {
        const practiceDiff = differences.find(
            (diff) => diff.practiceId === targetPracticeId
        );

        if (!practiceDiff) {
            return null;
        }

        const fieldDiff = practiceDiff.fields.find(
            (field) => field.fieldName === targetField
        );

        if (!fieldDiff || !fieldDiff.hasDifference) {
            return null;
        }

        return <Badge className="difference-badge">{'!'}</Badge>;
    };

    const columns = [
        {
            dataField: '_',
            text: 'OppID',
            headerClasses: 'opportunity-id-header',
            sort: false,
            formatter: (_: any, row: EngagementPractice) =>
                row == null ? <>NA</> : selectedOpportunity.opportunityId,
        },
        {
            dataField: 'companyName',
            text: 'Buyer / Client',
            hidden: !isExternalMember(),
            headerClasses: 'buyer-company-name-header',
            formatter: (cellContent: string) => {
                return cellContent ?? 'NA';
            },
            sort: false,
        },
        {
            dataField: 'ownerName',
            text: 'Owner Name',
            hidden: !selectedOpportunity.isIdNdaSigned,
            headerClasses: 'practice-name-header',
            sort: false,
            formatter: (cellContent: string, row: EngagementPractice) => {
                const cellValue = cellContent ?? 'NA';
                const differenceBadge = renderBadgeForDifference(
                    row.practiceId,
                    'ownerName',
                    dataDifferences
                );
                return (
                    <div className="cell-flex-container">
                        <div>{cellValue}</div>
                        <div>{differenceBadge}</div>
                    </div>
                );
            },
        },
        {
            dataField: 'practiceOwnershipType',
            text: 'Practice Ownership Type',
            headerClasses: 'practice-ownership-header',
            sort: false,
            formatter: (
                cellContent: OwnershipType,
                row: EngagementPractice
            ) => {
                const cellValue = !cellContent
                    ? 'NA'
                    : OwnershipTypeOptions[cellContent];
                const differenceBadge = renderBadgeForDifference(
                    row.practiceId,
                    'practiceOwnershipType',
                    dataDifferences
                );
                return (
                    <div className="cell-flex-container">
                        <div>{cellValue}</div>
                        <div>{differenceBadge}</div>
                    </div>
                );
            },
        },
        {
            dataField: 'stateOfRegistration',
            text: 'Location',
            hidden: selectedOpportunity.isIdNdaSigned,
            headerClasses: 'location-header',
            sort: false,
            formatter: (_: any, row: EngagementPractice) => {
                let cellValue = 'NA';
                if (row == null) {
                    return <>{cellValue}</>;
                }
                if (row.stateOfRegistration) {
                    cellValue = stateToCodeMapper(row.stateOfRegistration);
                }
                cellValue = stateToCodeMapper(row.location);

                const differenceBadge = renderBadgeForDifference(
                    row.practiceId,
                    'stateOfRegistration',
                    dataDifferences
                );
                return (
                    <div className="cell-flex-container">
                        <div>{cellValue}</div>
                        <div>{differenceBadge}</div>
                    </div>
                );
            },
        },
        {
            dataField: 'location',
            text: 'Location',
            hidden: !selectedOpportunity.isIdNdaSigned,
            headerClasses: 'location-header',
            sort: false,
        },
        {
            dataField: 'locationType',
            text: 'Location Type',
            headerClasses: 'fte-dvm-header',
            sort: false,
            formatter: (cellContent: LocationType, row: EngagementPractice) => {
                const cellValue = !cellContent
                    ? 'NA'
                    : LocationTypeOptions[cellContent];

                const differenceBadge = renderBadgeForDifference(
                    row.practiceId,
                    'locationType',
                    dataDifferences
                );
                return (
                    <div className="cell-flex-container">
                        <div>{cellValue}</div>
                        <div>{differenceBadge}</div>
                    </div>
                );
            },
        },
        {
            dataField: 'practiceType',
            text: 'Service Focus',
            headerClasses: 'practice-type-header',
            sort: false,
            formatter: (cellContent: number, row: EngagementPractice) => {
                const practiceType = isOtherFocus(serviceFocuses, cellContent)
                    ? row.otherPracticeType
                    : serviceFocuses.find((item) => item.id === cellContent)
                          ?.name ?? 'NA';
                const isOtherPracticeType =
                    isOtherFocus(serviceFocuses, cellContent) &&
                    row.otherPracticeType;

                const differenceBadge = renderBadgeForDifference(
                    row.practiceId,
                    isOtherPracticeType ? 'otherPracticeType' : 'practiceType',
                    dataDifferences
                );
                return (
                    <div className="cell-flex-container">
                        <div>{practiceType}</div>
                        <div>{differenceBadge}</div>
                    </div>
                );
            },
        },
        {
            dataField: 'fteDvms',
            text: 'FTE DVM',
            headerClasses: 'fte-dvm-header',
            sort: false,
            formatter: (cellContent: number, row: EngagementPractice) => {
                const cellValue = cellContent < 1 ? 0 : cellContent;
                const differenceBadge = renderBadgeForDifference(
                    row.practiceId,
                    'fteDvms',
                    dataDifferences
                );
                return (
                    <div className="cell-flex-container">
                        <div>{cellValue}</div>
                        <div>{differenceBadge}</div>
                    </div>
                );
            },
        },
        {
            dataField: 'revenueGrowthRate',
            text: 'Revenue Growth Rate',
            headerClasses: 'revenue-range-header',
            sort: false,
            formatter: (
                cellContent: RevenueGrowthRate,
                row: EngagementPractice
            ) => {
                const cellValue = !cellContent
                    ? 'NA'
                    : RevenueGrowthRateOptions[cellContent];
                const differenceBadge = renderBadgeForDifference(
                    row.practiceId,
                    'revenueGrowthRate',
                    dataDifferences
                );
                return (
                    <div className="cell-flex-container">
                        <div>{cellValue}</div>
                        <div>{differenceBadge}</div>
                    </div>
                );
            },
        },
    ];
    const [activeTab, setActiveTab] = useState<number>(
        BuyerOppMarketplaceTab.Timeline
    );
    const [searchParams, setSearchParams] = useSearchParams({});
    const marketplacePricing = useStateSelector(
        (state) => state.marketplacePricing.pricing
    );
    const [paymentPricingDetails, setPaymentPricingDetails] =
        useState<EngagementPaymentPricingDetails>();

    const [opportunityFteDvmsCount, setOpportunityFteDvmsCount] = useState(0);

    useEffect(() => {
        dispatch(LoadMarketplacePricing(selectedOpportunity.opportunityId));
    }, []);

    useEffect(() => {
        if (lastSelectedOpportunityId) {
            updateSearchParams({
                opportunityId: selectedOpportunity.opportunityId?.toString(),
                tab: isExternalMember()
                    ? BuyerOppMarketplaceTab.DataRoom.toString()
                    : BuyerOppMarketplaceTab.Timeline.toString(),
                subtab: (1).toString(),
            });
        }
        setLastSelectedOpportunityId(selectedOpportunity.opportunityId);
        const newAvailableTabs = BuyerOppMarketplaceTabs.filter((tab) =>
            isTabAvailable(tab.id)
        );
        setAvailaleTabs(newAvailableTabs);
        if (isExternalMember()) {
            setActiveTab(BuyerOppMarketplaceTab.DataRoom);
        }
        const fteDvmsCount = selectedOpportunity?.practices
            .map((practice) => practice.fteDvms)
            .reduce(
                (accumulator, currentValue) => accumulator + currentValue,
                0
            );
        setOpportunityFteDvmsCount(fteDvmsCount);
    }, [
        selectedOpportunity?.opportunityId,
        selectedOpportunity?.buyer?.isActive,
    ]);

    useEffect(() => {
        if (
            selectedOpportunity?.buyer?.opportunityBuyerStatus ===
            MarketplaceOpportunityStatus.Terminated
        ) {
            setActiveTab(BuyerOppMarketplaceTab.Documents);
            return;
        }
        const tabValue = searchParams.get('tab');
        const numberValue = Number(tabValue);
        const isTabValueValid =
            tabValue &&
            numberValue &&
            numberValue >= 1 &&
            numberValue <= tabComponents.length;
        if (isTabValueValid) {
            if (
                isExternalMember() &&
                numberValue !== BuyerOppMarketplaceTab.Documents &&
                numberValue !== BuyerOppMarketplaceTab.DataRoom
            ) {
                setActiveTab(BuyerOppMarketplaceTab.Documents);
            } else {
                setActiveTab(numberValue);
            }
        } else {
            updateSearchParams({
                tab: (1).toString(),
                subtab: searchParams.get('subtab'),
                opportunityId: searchParams.get('opportunityId'),
            });
        }
    }, [searchParams]);

    const getDocumentToSign = (
        documentId: string,
        prefilledTags: PrefilledTags[],
        eventId: string
    ) => {
        setIsDocumentToSignFetching(true);
        axios
            .post(
                `/api/marketplace/engagements/${selectedOpportunity.opportunityId}/documents/${documentId}/sign`,
                prefilledTags
            )
            .then((response) => {
                if (response.status === 402) {
                    dispatch(
                        GetOpportunity(selectedOpportunity.opportunityId)
                    ).then((response: any) => {
                        const udatedOpportunity = response.payload
                            .opportunity as MarketplaceOpportunity;
                        const events = udatedOpportunity.events;
                        const selectedEvent = events.find(
                            (x) => x.id === eventId
                        );
                        const { actionType, id } = selectedEvent.linkedAction;
                        const selectedActionState =
                            udatedOpportunity?.buyer?.actionState.find(
                                (f) => f.actionId === id
                            );
                        handlePaymentRequiredException(
                            eventId,
                            actionType,
                            selectedActionState.documentDetailsId
                        );
                    });
                    return;
                }

                if (response.status !== 200) {
                    createNotification(
                        'An unexpected error occurred while getting Document',
                        'error'
                    );
                    setIsDocumentToSignFetching(false);
                    return;
                }

                setDocumentToSign(response.data);

                setIsLegalDocumentInfoConfirmationPopupVisible(false);
                setIsDocumentToSignFetching(false);
            })
            .catch(() => {
                createNotification(
                    'An unexpected error occurred while getting Document',
                    'error'
                );
            })
            .finally(() => {});
    };

    const handlePaymentRequiredException = (
        eventId: string,
        actionType: TimelineActionType,
        documentId?: string
    ) => {
        setIsDocumentToSignFetching(false);
        setIsLegalDocumentInfoConfirmationPopupVisible(false);

        switch (actionType) {
            case TimelineActionType.SellerBuyerSelectionIdNda:
                const idNdaExecutionFeeDetails =
                    PricesCalculationHelper.getIdNDAExecutionFeeDetails(
                        marketplacePricing,
                        opportunityFteDvmsCount
                    );
                setPaymentPricingDetails({
                    pricePerFteDvm: idNdaExecutionFeeDetails.pricePerItem,
                    fteDvmsCount: idNdaExecutionFeeDetails.itemsCount,
                    creditablePercent:
                        idNdaExecutionFeeDetails.creditablePercent,
                    creditableAmount: idNdaExecutionFeeDetails.creditableAmount,
                    totalPrice: idNdaExecutionFeeDetails.totalPrice,
                    engagementId: selectedOpportunity.opportunityId,
                    eventId: eventId,
                    documentType: EngagementDocumentType.IdNda,
                    documentId: documentId,
                });
                setIsDocumentAccessFeeCheckoutPopupVisible(true);
                return;
            case TimelineActionType.SellerCustomSelectDataNdaTerms:
                const dataNdaExecutionFeeDetails =
                    PricesCalculationHelper.getDataNDAExecutionFeeDetails(
                        marketplacePricing,
                        opportunityFteDvmsCount
                    );
                setPaymentPricingDetails({
                    pricePerFteDvm: dataNdaExecutionFeeDetails.pricePerItem,
                    fteDvmsCount: dataNdaExecutionFeeDetails.itemsCount,
                    creditablePercent:
                        dataNdaExecutionFeeDetails.creditablePercent,
                    creditableAmount:
                        dataNdaExecutionFeeDetails.creditableAmount,
                    totalPrice: dataNdaExecutionFeeDetails.totalPrice,
                    engagementId: selectedOpportunity.opportunityId,
                    eventId: eventId,
                    documentType: EngagementDocumentType.DataNda,
                    documentId: documentId,
                });
                setIsDocumentAccessFeeCheckoutPopupVisible(true);
                return;
            default:
                return;
        }
    };

    const handleOnDocumentDownloaded = (documentDetailsId: string) => {
        if (!selectedOpportunity?.buyer?.isActive) {
            return;
        }

        let docDetails = selectedOpportunity.engagementData.documentsList.find(
            (d) => d.id == documentDetailsId
        );

        if (docDetails?.id != docDetails?.masterDocumentId) {
            docDetails = selectedOpportunity.engagementData.documentsList.find(
                (d) =>
                    d.id == d.masterDocumentId &&
                    d.id == docDetails.masterDocumentId &&
                    !!d.additionalVersionIds &&
                    d.additionalVersionIds.includes(documentDetailsId)
            );
        }

        const documentEvent = selectedOpportunity.events.find(
            (e) => e?.linkedAction?.referenceItemId === docDetails.id
        );

        const isBuyerReviewDocumentAction =
            documentEvent?.linkedAction?.actionType ===
            TimelineActionType.BuyerReviewDocument;

        const pipOrDfmDocuments =
            selectedOpportunity.engagementData.documentsList.filter(
                (x) =>
                    x.contentType ===
                        DocumentDetailsContentType.FinancialModel ||
                    x.contentType === DocumentDetailsContentType.PipOrPiq
            );
        const isPipOrDFMAction = pipOrDfmDocuments.some(
            (x) => x.id === documentDetailsId
        );

        const canReview = canUserReviewDocument();
        if (canReview && (isBuyerReviewDocumentAction || isPipOrDFMAction)) {
            const postObject = {
                actionId: documentEvent.linkedAction.id,
                documentDetailsId: documentDetailsId,
            };
            axios
                .post(
                    `/api/Marketplace/${selectedOpportunity.opportunityId}/MarketplaceOpportunityDocuments/buyerDocumentStatus`,
                    postObject
                )
                .then((response) => {
                    if (response.status === 200) {
                        dispatch(
                            GetOpportunity(selectedOpportunity.opportunityId)
                        ).then(() => {
                            dispatch(
                                setSelectedOpportunity(
                                    selectedOpportunity.opportunityId
                                )
                            );
                        });
                    }
                });
        }
    };

    const handleRangeOfValueConfirm = (
        eventId: string,
        minPrice: number,
        maxPrice: number
    ) => {
        const postObject = {
            actionId: selectedActionId,
            minPrice: minPrice,
            maxPrice: maxPrice,
        };

        let tempOpportunityId = selectedOpportunity.opportunityId;
        setIsConfirmingRangeOfValue(true);
        axios
            .post(
                `api/Marketplace/${selectedOpportunity.opportunityId}/MarketplaceEventActions/CompleteRangeOfValue`,
                postObject
            )
            .then((response) => {
                if (response.status === 200) {
                    setIsRangeOfValueVisible(false);

                    dispatch(GetOpportunity(tempOpportunityId)).then(() => {
                        dispatch(setSelectedOpportunity(tempOpportunityId));
                        props.refreshOpportunities();
                    });
                } else {
                    createNotification(
                        'Some unexpected error occured while confirming range of value.',
                        'error'
                    );
                }
            })
            .finally(() => setIsConfirmingRangeOfValue(false))
            .catch(() => {
                createNotification(
                    'Some unexpected error occured while confirming range of value.',
                    'error'
                );
                setIsConfirmingRangeOfValue(false);
            });
    };

    const updateSearchParams = (params: { [key: string]: string }) => {
        const newParams: Record<string, string> = {};
        newParams.opportunityId =
            params.opportunityId ??
            selectedOpportunity?.opportunityId?.toString();
        newParams.tab = params.tab ?? activeTab.toString();
        if (params.subtab !== undefined && params.subtab !== null) {
            newParams.subtab = params.subtab;
        }
        setSearchParams(newParams);
    };

    const isReadonlyDueToPermissions = (): boolean => {
        return (
            TeamMemberPermissionsHelper.isAvailable(
                currentPermissions,
                TeamMemberPermissionsHelper.requiredViewPermissions
            ) &&
            !TeamMemberPermissionsHelper.isAvailable(
                currentPermissions,
                TeamMemberPermissionsHelper.requiredEditPermissions
            )
        );
    };

    const canUserReviewDocument = (): boolean => {
        return TeamMemberPermissionsHelper.isAvailable(
            currentPermissions,
            TeamMemberPermissionsHelper.requiredEditPermissions
        );
    };

    const tabComponents = [
        {
            id: BuyerOppMarketplaceTab.Timeline,
            content: (
                <EngagementTimeline
                    onEventClick={(id: string) => {
                        onEventClick(id);
                    }}
                    startDate={selectedOpportunity.listingDate}
                    events={selectedOpportunity.events}
                    buyerActionState={
                        selectedOpportunity?.buyer?.actionState ?? []
                    }
                    engagementData={selectedOpportunity.engagementData}
                    id={selectedOpportunity.opportunityId}
                    isReadOnly={
                        !selectedOpportunity?.buyer ||
                        selectedOpportunity?.buyer?.opportunityBuyerStatus ===
                            MarketplaceOpportunityStatus.Suspended ||
                        isReadonlyDueToPermissions()
                    }
                    setSearchParams={updateSearchParams}
                    isBuyerView={true}
                />
            ),
            notificationFlag: `${NotificationFlagsCategories.MpCode}.${NotificationFlagsCategories.OpportunitiesCode}.${selectedOpportunity.opportunityId}.${NotificationFlagsCategories.EngagementTimelinePreviewCode}`,
        },
        {
            id: BuyerOppMarketplaceTab.DeadlineDocket,
            content: (
                <DeadlineDocket
                    engagementId={selectedOpportunity.opportunityId}
                    engagementStartDate={selectedOpportunity.listingDate}
                    onEventClick={(id: string) => {
                        onEventClick(id);
                    }}
                    buyerActionState={
                        selectedOpportunity?.buyer?.actionState ?? []
                    }
                    engagementData={selectedOpportunity.engagementData}
                    events={selectedOpportunity.events}
                    opportunityStatus={selectedOpportunity.status}
                    notificationFlagPrefix={`${NotificationFlagsCategories.MpCode}.${NotificationFlagsCategories.OpportunitiesCode}.${selectedOpportunity.opportunityId}.${NotificationFlagsCategories.DeadlineDocketCode}`}
                />
            ),
            notificationFlag: `${NotificationFlagsCategories.MpCode}.${NotificationFlagsCategories.OpportunitiesCode}.${selectedOpportunity.opportunityId}.${NotificationFlagsCategories.DeadlineDocketCode}`,
        },
        {
            id: BuyerOppMarketplaceTab.Documents,
            content: (
                <BuyersEngagementDocuments
                    setShouldUploadDocument={setShouldUploadDocument}
                    engagementData={selectedOpportunity.engagementData}
                    preSelectedDocumentId={highlightDocumentId}
                    setPreSelectedDocumentId={(docId?: string) =>
                        setHighlightDocumentId(docId)
                    }
                    isReadonly={isReadonlyDueToPermissions()}
                    actionIdForFileUpload={actionIdForDocumnetUpload}
                    shouldUploadDocument={shouldUploadDocument}
                    onDocumentDownloaded={handleOnDocumentDownloaded}
                />
            ),
            notificationFlag: `${NotificationFlagsCategories.MpCode}.${NotificationFlagsCategories.OpportunitiesCode}.${selectedOpportunity.opportunityId}.${NotificationFlagsCategories.EngagementDocumentsCode}`,
        },
        {
            id: BuyerOppMarketplaceTab.CommsHub,
            content: (
                <MarketplaceCommsHub
                    notificationFlagPrefix={`${NotificationFlagsCategories.MpCode}.${NotificationFlagsCategories.OpportunitiesCode}`}
                    engagement={selectedOpportunity as unknown as Timeline}
                />
            ),
            notificationFlag: `${NotificationFlagsCategories.MpCode}.${NotificationFlagsCategories.OpportunitiesCode}.${selectedOpportunity.opportunityId}.${NotificationFlagsCategories.CommsHubCode}`,
        },
        {
            id: BuyerOppMarketplaceTab.EngagementHistory,
            content: (
                <EngagementHistoryTable
                    canNavigateToTransaction={
                        selectedOpportunity.isPrimaryBuyer
                    }
                    engagementId={selectedOpportunity.opportunityId}
                    engagementData={selectedOpportunity.engagementData}
                    events={selectedOpportunity.events}
                    viewParty={TimelineParty.Buyer}
                    onEventClick={(eventId) => onEventClick(eventId)}
                    isReadonly={
                        !selectedOpportunity?.buyer ||
                        selectedOpportunity?.buyer?.opportunityBuyerStatus ===
                            MarketplaceOpportunityStatus.Suspended ||
                        isReadonlyDueToPermissions()
                    }
                    refreshTrigger={engagementHistoryRefreshTrigger}
                    currentBuyerActionState={
                        selectedOpportunity?.buyer?.actionState ?? []
                    }
                />
            ),
        },
        {
            id: BuyerOppMarketplaceTab.DealTeam,
            content: (
                <DealTeam
                    isReadonly={!selectedOpportunity.isPrimaryBuyer}
                    opportunityId={selectedOpportunity.opportunityId}
                    buyer={selectedOpportunity.buyer}
                />
            ),
        },
        {
            id: BuyerOppMarketplaceTab.DataRoom,
            content: <OpportunityDataRoomHost />,
        },
        {
            id: BuyerOppMarketplaceTab.SellerProfile,
            content: <SellerProfileTab opportunity={selectedOpportunity} />,
        },
        {
            id: BuyerOppMarketplaceTab.ProcessCommercialTerms,
            content: (
                <CurrentProcessCommercialTerms
                    engagementId={selectedOpportunity.opportunityId}
                />
            ),
        },
    ];

    const switchToDocTab = () =>
        updateSearchParams({
            tab: Number(BuyerOppMarketplaceTab.Documents).toString(),
        });

    const onEventClick = (eventId: string) => {
        if (isDocumentToSignFetching || isReadonlyDueToPermissions()) {
            return;
        }

        const guid = eventId.replace('event-', '');
        const events = selectedOpportunity.events;
        const selectedEvent = events.find((x) => x.id === guid);

        if (!selectedEvent?.linkedAction) return;

        const { actionType, id, referenceItemId } = selectedEvent.linkedAction;
        const selectedActionState =
            selectedOpportunity?.buyer?.actionState.find(
                (f) => f.actionId === id
            );

        if (
            selectedActionState?.status !== TimelineActionStatus.Completed &&
            !isBuyerActive() &&
            actionType !==
                TimelineActionType.BuyerExpressionOfInterestWithRange &&
            actionType !== TimelineActionType.BuyerReviewDocument
        ) {
            return;
        }

        setSelectedEventId(guid);
        setSelectedActionId(id);

        switch (actionType) {
            case TimelineActionType.BuyerReviewDocument:
                switchToDocTab();
                setHighlightDocumentId(referenceItemId);
                break;

            case TimelineActionType.BuyerUploadDocument:
                switchToDocTab();
                if (
                    selectedActionState?.status ===
                        TimelineActionStatus.Completed &&
                    selectedActionState.documentDetailsId
                ) {
                    setHighlightDocumentId(
                        selectedActionState.documentDetailsId
                    );
                } else {
                    setShouldUploadDocument(true);
                    setActionIdForDocumnetUpload(id);
                }
                break;

            case TimelineActionType.BuyerExpressionOfInterestWithRange:
                if (
                    (selectedActionState?.status ===
                        TimelineActionStatus.Completed &&
                        selectedActionState.minPrice &&
                        selectedActionState.maxPrice) ||
                    !isBuyerActive()
                ) {
                    setRangeOfValueMinValue(selectedActionState?.minPrice ?? 0);
                    setRangeOfValueMaxValue(selectedActionState?.maxPrice ?? 0);
                }

                const isEventActive =
                    selectedEvent.status === TimelineEventStatus.InProgress ||
                    selectedEvent.status === TimelineEventStatus.Late;
                setIsRangeOfValueReadonly(!isEventActive);

                setIsRangeOfValueVisible(true);
                break;
            case TimelineActionType.SellerBuyerSelectionDetailedFinancialModel:
                {
                    const fmDocuments =
                        selectedOpportunity.engagementData?.documentsList?.filter(
                            (d) =>
                                d.contentType ===
                                    DocumentDetailsContentType.FinancialModel &&
                                d.status === DocumentDetailsStatus.Completed
                        );

                    const targetDocumentId =
                        selectedActionState?.documentDetailsId ||
                        (fmDocuments && fmDocuments.length
                            ? fmDocuments[0].id
                            : undefined);

                    if (targetDocumentId) {
                        switchToDocTab();
                        setHighlightDocumentId(targetDocumentId);
                    }
                }
                break;
            case TimelineActionType.BuyerDocumentExecution:
                if (
                    selectedActionState?.status !==
                        TimelineActionStatus.Completed &&
                    selectedEvent.status === TimelineEventStatus.Completed
                ) {
                    return;
                }
                if (
                    selectedActionState?.status ===
                    TimelineActionStatus.Completed
                ) {
                    setHighlightDocumentId(
                        selectedActionState.documentDetailsId
                    );
                    switchToDocTab();
                } else {
                    const buyerDocumentToSignExist =
                        selectedOpportunity.engagementData.documentsList.find(
                            (document) =>
                                document.id ===
                                selectedActionState?.documentDetailsId
                        );

                    if (buyerDocumentToSignExist) {
                        getDocumentToSign(
                            buyerDocumentToSignExist.id,
                            [],
                            selectedEvent.id
                        );
                    } else {
                        setIsLegalDocumentInfoConfirmationPopupVisible(true);
                    }
                }
                break;

            case TimelineActionType.SellerBuyerSelectionIdNda:
                if (
                    selectedActionState?.status !==
                        TimelineActionStatus.Completed &&
                    selectedEvent.status === TimelineEventStatus.Completed
                ) {
                    return;
                }
                if (
                    selectedActionState?.status ===
                    TimelineActionStatus.Completed
                ) {
                    setHighlightDocumentId(
                        selectedActionState.documentDetailsId
                    );
                    switchToDocTab();
                } else {
                    const buyerDocumentToSignExist =
                        selectedOpportunity.engagementData.documentsList.find(
                            (document) =>
                                document.id ===
                                selectedActionState?.documentDetailsId
                        );
                    if (buyerDocumentToSignExist) {
                        getDocumentToSign(
                            buyerDocumentToSignExist.id,
                            [],
                            selectedEvent.id
                        );
                    } else {
                        setIsLegalDocumentInfoConfirmationPopupVisible(true);
                    }
                }
                break;
            case TimelineActionType.SellerCustomSelectDataNdaTerms:
                const action = selectedEvent.linkedAction;

                if (!action) {
                    break;
                }

                const selection =
                    selectedOpportunity.engagementData.ndaTermSelectionList.find(
                        (x) => x.id === action.dataNdaTermId
                    );

                const buyerActionState =
                    selectedOpportunity.buyer?.actionState?.find(
                        (a) => a.actionId === action.id
                    );
                if (
                    buyerActionState.buyerStatus ===
                    MarketplaceOpportunityStatus.RejectedBySeller
                ) {
                    createNotification(
                        selection.isLockedIn
                            ? 'You are not allowed to execute NDA because you were not selected by Seller.'
                            : 'You are not allowed to proceed as you were not selected by Seller yet.',
                        'warning'
                    );
                    break;
                }

                if (!selection) {
                    createNotification(
                        'You are not allowed to select terms until the Seller has submitted selection.',
                        'warning'
                    );
                    break;
                }
                const sellerNda = selection.ndaTermsList.find(
                    (x) => x.party === TimelineParty.Seller
                );
                if (!sellerNda) {
                    createNotification(
                        'You are not allowed to select terms until the Seller has submitted selection.',
                        'warning'
                    );
                    break;
                }
                setActiveEventId(selectedEvent.id);

                const buyerSelection = selection.ndaTermsList.find(
                    (x) =>
                        x.party === TimelineParty.Buyer &&
                        !!x.agreedTermsToDocumentList?.length &&
                        x.buyerId == buyer.id
                );

                if (buyerSelection) {
                    if (
                        !buyerSelection.agreedTermsToDocumentList?.length &&
                        selection.isLockedIn
                    ) {
                        createNotification(
                            'You are not allowed to execute NDA because no agreement on terms has been reached.',
                            'warning'
                        );
                    } else if (
                        buyerSelection.agreedTermsToDocumentList?.some(
                            (s) => s.isLocked
                        )
                    ) {
                        const maxDateLockedItem =
                            buyerSelection.agreedTermsToDocumentList.reduce(
                                (maxItem, currentItem) => {
                                    if (!maxItem) return currentItem;

                                    const maxDate = new Date(
                                        maxItem.dateLocked
                                    );
                                    const currentDate = new Date(
                                        currentItem.dateLocked
                                    );

                                    return currentDate > maxDate
                                        ? currentItem
                                        : maxItem;
                                },
                                null
                            );

                        const buyerDocumentToSignExist =
                            selectedOpportunity.engagementData.documentsList.find(
                                (document) =>
                                    document.id ===
                                    maxDateLockedItem?.documentDetailsId
                            );

                        if (buyerDocumentToSignExist) {
                            if (
                                buyerDocumentToSignExist.status ===
                                    DocumentDetailsStatus.Completed ||
                                buyerActionState.status ===
                                    TimelineActionStatus.Completed
                            ) {
                                setHighlightDocumentId(
                                    selectedActionState.documentDetailsId
                                );
                                switchToDocTab();
                            } else {
                                getDocumentToSign(
                                    buyerDocumentToSignExist.id,
                                    [],
                                    selectedEvent.id
                                );
                            }

                            break;
                        } else {
                            setIsFinalNdaTermPopupVisible(true);
                            setNdaTermSelection(selection);
                        }
                    } else {
                        setIsNdaTermPopupVisible(true);
                    }
                } else {
                    setIsNdaTermPopupVisible(true);
                }

                break;
            default:
                break;
        }
    };

    const renderTabContent = () => {
        const activeTabData = tabComponents
            .filter((tab) => isTabAvailable(tab.id))
            .find((tab) => tab.id === activeTab);
        return activeTabData?.content || <></>;
    };

    const doesBuyerExist = () => !!selectedOpportunity?.buyer;

    const isBuyerActive = () => selectedOpportunity?.buyer?.isActive;

    const isEngagementTerminated = () => {
        return (
            selectedOpportunity?.buyer?.opportunityBuyerStatus ===
            MarketplaceOpportunityStatus.Terminated
        );
    };

    const isDataNdaSigned = () => {
        return selectedOpportunity?.isDataNdaSigned;
    };

    const isIdNdaSigned = () => {
        return selectedOpportunity?.isIdNdaSigned;
    };

    const isAvailableToSeeVdr = () => {
        return selectedOpportunity?.buyer?.isVdrAvailable;
    };

    const isTabAvailable = (tab: BuyerOppMarketplaceTab): boolean => {
        if (!hasPermissionsToViewTab(tab)) {
            return false;
        }
        switch (tab) {
            case BuyerOppMarketplaceTab.Documents:
                return doesBuyerExist();
            case BuyerOppMarketplaceTab.Timeline:
                return !isEngagementTerminated();
            case BuyerOppMarketplaceTab.DeadlineDocket:
                return !isEngagementTerminated();
            case BuyerOppMarketplaceTab.CommsHub:
                return isDataNdaSigned() && is28Implemented && isBuyerActive();
            case BuyerOppMarketplaceTab.DealTeam:
                return isFF_MrktplcBuyers_3_6Enabled;
            case BuyerOppMarketplaceTab.DataRoom:
                return (
                    isFF_MrktplcBuyers_3_8Enabled &&
                    isDataNdaSigned() &&
                    isIdNdaSigned() &&
                    isAvailableToSeeVdr()
                );
            case BuyerOppMarketplaceTab.SellerProfile:
                return doesBuyerExist();
            case BuyerOppMarketplaceTab.ProcessCommercialTerms:
                const requiredPermissions = {
                    isPrimaryBuyer: false,
                    type: TeamMemberType.Internal,
                    role: InternalTeamMemberRole.CorpDev,
                    permission: null,
                } as TeamMemberPermissions;
                const currentPermissions = {
                    isPrimaryBuyer: buyerProfile.teamMemberRole.isPrimaryBuyer,
                    type: buyerProfile.teamMemberRole.teamMemberType,
                    role: buyerProfile.teamMemberRole.internalTeamMemberRole,
                    permission: null,
                } as TeamMemberPermissions;
                return (
                    doesBuyerExist() &&
                    (selectedOpportunity.isPrimaryBuyer ||
                        TeamMemberPermissionsHelper.isAvailable(
                            currentPermissions,
                            requiredPermissions
                        ))
                );
            default:
                return true;
        }
    };

    const hasPermissionsToViewTab = (tab: BuyerOppMarketplaceTab) => {
        if (selectedOpportunity.teamMemberType === TeamMemberType.External) {
            return (
                tab === BuyerOppMarketplaceTab.DataRoom ||
                tab === BuyerOppMarketplaceTab.CommsHub ||
                tab === BuyerOppMarketplaceTab.Documents
            );
        }
        return true;
    };

    const getTabNotificationFlag = (tab: number) => {
        const targetCode = tabComponents.find((t) => t.id === tab);
        return targetCode ? (
            <>
                <NotificationFlag
                    flagClassName="notification-flag-wrapper"
                    eventCode={targetCode.notificationFlag}
                    includePrefix={true}
                />
            </>
        ) : (
            <></>
        );
    };

    const renderTabs = () => {
        return (
            <div className="practice-page-tabs m-0">
                <div className="body_inner_content">
                    <div className="RRT__container">
                        <div className="RRT__tabs body-tabs">
                            {availableTabls?.map((item) => {
                                return (
                                    <div
                                        key={item.id}
                                        className={
                                            activeTab === item.id
                                                ? 'RRT__tab RRT__tab--first RRT__tab--selected'
                                                : 'RRT__tab'
                                        }
                                        onClick={async () => {
                                            setActiveTab(item.id);
                                            updateSearchParams({
                                                tab: item.id.toString(),
                                            });
                                            await dispatch(
                                                RefreshNotificationFlags()
                                            );
                                        }}>
                                        {item.content}
                                        {getTabNotificationFlag(item.id)}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    {renderTabContent()}
                </div>
            </div>
        );
    };

    const renderDetails = () => {
        const data = selectedOpportunity.practices.map((practice) => ({
            ...practice,
            companyName: selectedOpportunity.buyer?.companyName || '',
            differences: dataDifferences,
        }));

        return (
            <div className="body_inner_content details-table-wrapper">
                <BootstrapTable
                    bootstrap4
                    remote
                    keyField="id"
                    data={data}
                    columns={columns}
                    noDataIndication="No data available"
                />
            </div>
        );
    };

    const renderHeader = () => {
        return (
            <div className="header-container">
                <span>{'Opportunity Details'}</span>
                <div className="buyer-state-nf-wrapper">
                    <div className="status-container">
                        {'Status: '}
                        <span
                            className="status-text"
                            style={{
                                color: MarketplaceOpportunityStatusList.find(
                                    (x) => x.id == selectedOpportunity.status
                                ).color,
                            }}>
                            {
                                MarketplaceOpportunityStatusList.find(
                                    (x) => x.id == selectedOpportunity.status
                                )?.name
                            }
                        </span>
                        <NotificationFlag
                            eventCode={`${NotificationFlagsCategories.MpCode}.${NotificationFlagsCategories.OpportunitiesCode}.${selectedOpportunity.opportunityId}.${NotificationFlagsCategories.OpportunityStatusCode}`}
                        />
                    </div>
                </div>

                <div className="start-day-container">
                    {'Engagement Date: '}
                    <span className="label">
                        {moment(selectedOpportunity.listingDate).format('l')}
                    </span>
                </div>
                <div className="process-type-container">
                    {'Process Type: '}
                    <span className="label">
                        {
                            LevelsOfService.find(
                                (f) =>
                                    f.id === selectedOpportunity.levelOfService
                            )?.name
                        }
                    </span>
                </div>
                {summary.roleId === USER_ROLES.PRACTICE_SECONDARY_USER && (
                    <div className="process-type-container">
                        {'My Access: '}
                        <span className="label">{getMyAccessLevel()}</span>
                    </div>
                )}
            </div>
        );
    };

    const getMyAccessLevel = () => {
        return selectedOpportunity.teamMemberType === TeamMemberType.External
            ? TeamMemberPermissionsHelper.getExternalPermissionLabel(
                  selectedOpportunity.externalPermissions
              )
            : TeamMemberPermissionsHelper.getInternalPermissionLabel(
                  selectedOpportunity.internalPermissions
              );
    };

    const getTargetDocumentType = () => {
        const events = selectedOpportunity.events;
        const selectedEvent = events.find((x) => x.id === selectedEventId);
        const documentId = selectedEvent?.linkedAction?.referenceItemId;
        const document = selectedOpportunity.engagementData.documentsList.find(
            (d) => d.id === documentId
        );
        return document?.type;
    };

    const handleScussessfulPayment = () => {
        dispatch(GetOpportunity(selectedOpportunity.opportunityId));
        setIsDocumentAccessFeeCheckoutPopupVisible(false);
        onEventClick(selectedEventId);
    };
    const summary = useStateSelector((state) => state.userSummary.summary);

    return (
        <div className="opportunity-details body_white_box ">
            <Card>
                <CardHeader>{renderHeader()}</CardHeader>
                <CardBody>
                    {renderDetails()}
                    {renderTabs()}
                </CardBody>
            </Card>

            {isLegalDocumentInfoConfirmationPopupVisible ? (
                <LegalDocumentInformationPopup
                    isLoading={isDocumentToSignFetching}
                    opportunityId={selectedOpportunity.opportunityId}
                    onSubmit={(prefilledTags) => {
                        const events = selectedOpportunity.events;
                        const selectedEvent = events.find(
                            (x) => x.id === selectedEventId
                        );

                        getDocumentToSign(
                            selectedEvent?.linkedAction?.referenceItemId,
                            prefilledTags,
                            selectedEvent?.id
                        );
                    }}
                    onClose={() =>
                        setIsLegalDocumentInfoConfirmationPopupVisible(false)
                    }
                    documentType={getTargetDocumentType()}
                />
            ) : (
                <></>
            )}

            {documentToSign ? (
                <DocumentSignModal
                    documentId={documentToSign}
                    isVisible={!!documentToSign}
                    onClose={() => setDocumentToSign(undefined)}
                    onSign={() => {
                        setTimeout(() => {
                            setDocumentToSign(undefined);
                            createNotification(
                                'Document signed successfully',
                                'success'
                            );
                            props.refreshOpportunities();
                        }, 2000);
                        dispatch(
                            GetOpportunity(selectedOpportunity.opportunityId)
                        );
                    }}
                />
            ) : (
                []
            )}
            {isNdaTermPopupVisible && (
                <NdaTermsPopup
                    engagementData={selectedOpportunity.engagementData}
                    engagementProcess={null}
                    engagementId={selectedOpportunity.opportunityId}
                    events={selectedOpportunity.events}
                    isVisible={isNdaTermPopupVisible}
                    fetchData={() => {
                        dispatch(
                            GetOpportunity(selectedOpportunity.opportunityId)
                        );
                    }}
                    activeEventId={activeEventId}
                    setIsVisible={setIsNdaTermPopupVisible}
                    levelOfService={selectedOpportunity.levelOfService}
                />
            )}
            {isFinalNdaTermPopupVisible && (
                <FinalNdaTermsPopup
                    ndaTermSelection={ndaTermSelection}
                    engagementId={selectedOpportunity.opportunityId}
                    isVisible={isFinalNdaTermPopupVisible}
                    fetchData={() => {
                        dispatch(
                            GetOpportunity(selectedOpportunity.opportunityId)
                        );
                    }}
                    onSubmit={() => {
                        setIsLegalDocumentInfoConfirmationPopupVisible(true);
                    }}
                    setIsVisible={setIsFinalNdaTermPopupVisible}
                />
            )}
            {isRangeOfValueVisible ? (
                <ValueRangeModal
                    isRangeOfValueVisible={isRangeOfValueVisible}
                    onClose={() => setIsRangeOfValueVisible(false)}
                    onRangeOfValueConfirm={handleRangeOfValueConfirm}
                    selectedEventId={selectedEventId}
                    isRangeOfValueReadonly={isRangeOfValueReadonly}
                    minValue={rangeOfValueMinValue}
                    maxValue={rangeOfValueMaxValue}
                    isConfirmationInProgress={isConfirmingRangeOfValue}
                />
            ) : (
                <></>
            )}
            {isDocumentAccessFeeCheckoutPopupVisible && (
                <EngagementDocumentAccessPaymentComponent
                    isVisible={isDocumentAccessFeeCheckoutPopupVisible}
                    setIsVisible={setIsDocumentAccessFeeCheckoutPopupVisible}
                    paymentSuccess={() => handleScussessfulPayment()}
                    engagementId={selectedOpportunity.opportunityId}
                    eventId={selectedEventId}
                    fteDvmsCount={paymentPricingDetails.fteDvmsCount}
                    pricePerFteDmv={paymentPricingDetails.pricePerFteDvm}
                    totalPrice={paymentPricingDetails.totalPrice}
                    creditableAmount={paymentPricingDetails.creditableAmount}
                    documentType={paymentPricingDetails.documentType}
                    documentId={paymentPricingDetails.documentId}
                />
            )}
        </div>
    );
};
